import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { useCoreReady } from '../../store/data';
import PageHeader from '../../components/kit/PageHeader';
import LeafHeader from '../../components/kit/LeafHeader';
import EnvelopeTab from './EnvelopeTab';

export default function Budget() {
  const ready = useCoreReady();
  const now = new Date();
  const [ym, setYm] = useState({ y: now.getFullYear(), m: now.getMonth() + 1 });
  const step = (n: number) => { const d = new Date(ym.y, ym.m - 1 + n, 1); setYm({ y: d.getFullYear(), m: d.getMonth() + 1 }); };

  return (
    <div className="space-y-5">
      <PageHeader title="Ngân sách" question="Tháng này còn bao nhiêu?" />
      <p className="flex items-start gap-2 text-muted-foreground">
        <CalendarClock size={16} className="mt-1 shrink-0" aria-hidden />
        <span>Khoản "đã cam kết" là các khoản dự chi đang chờ. Xác nhận, sửa hoặc thêm ở <Link to="/v2/du-kien" className="font-medium text-primary hover:underline">Dự kiến</Link>.</span>
      </p>
      {!ready ? <div className="space-y-3"><Skeleton className="h-40" /><Skeleton className="h-40" /></div> : <EnvelopeTab year={ym.y} month={ym.m} header={<LeafHeader month={ym.m} year={ym.y} onStep={step} />} />}
    </div>
  );
}
